import type { RootState } from "types/redux";

export const getAudioPlayerFile = (state: RootState) => state.domains.audioPlayer.file;

export const getIsAudioVisible = (state: RootState) => !!state.domains.audioPlayer.file;
